import { Navigate, Route, Routes } from "react-router-dom";
import { ComparePage } from "../pages/ComparePage";
import { HomePage } from "../pages/HomePage";
import { ResidencePage } from "../pages/ResidencePage";
import { ResidencePageRedirect } from "../pages/ResidencePageRedirect";

export function AuthenticatedLayout() {
  return (
    <Routes>
      <Route element={<HomePage />} path="/" />
      <Route path="/residence/:residenceId">
        <Route element={<ResidencePageRedirect />} index />
        <Route element={<ResidencePage />} path="situation/:situationId" />
      </Route>
      <Route
        element={<ComparePage />}
        path="/residence/:residenceId/situation/:situationId/compare/:scenarioIds"
      />
      <Route element={<Navigate to="/" />} path="*" />
    </Routes>
  );
}
